<div :class="classes">
    <div>
        <v-icon
            v-if="!locked"
            class="side-filter-icon"
            size="large"
            @click="changeState">
            mdi-arrow-collapse-left
        </v-icon>
        <span class="side-filter-text">{{ label }}</span>
    </div>
    <slot v-if="isActive || locked"></slot>
</div>